export function customerIconUrlFromCustomerName(customerName: string): string {
  return `assets/images/customers/${customerName.toLowerCase().trim()}/icon.png`;
}

export function customerLogoUrlFromCustomerName(customerName: string): string {
  return `assets/images/customers/${customerName.toLowerCase().trim()}/logo.png`;
}
